/* global bz_app, $ */
import defaultConfigModule from './default_config_module'

bz_app.config(defaultConfigModule)
